// extracted by mini-css-extract-plugin
export default {"registration-input":"styles_registration-input__oVvGW","input-error":"styles_input-error__FNI+X"};